import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {

  // Generic methods
  setItem(key: string, value: any): void {
    if (typeof value === 'string') {
      sessionStorage.setItem(key, value);
    } else {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  }

 getItem<T extends string | number | boolean | object>(key: string): T | null {
  const item = sessionStorage.getItem(key);
  if (item === null || item === undefined) return null;

  try {
    const parsed = JSON.parse(item);
    return parsed as T;
  } catch {
    // Not valid JSON → return as raw string
    return item as unknown as T;
  }
}


  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  clear(): void {
    sessionStorage.clear();
  }

  // Token helpers
  setToken(token: string): void {
    sessionStorage.setItem('token', token);
  }

  getToken(): string | null {
    return sessionStorage.getItem('token');
  }

  // Username / UserId helpers
  setUsername(username: string): void {
    this.setItem('username', username);
  }

  getUsername(): string | null {
    // Read raw — a numeric username (e.g. "728") must stay a string, not be
    // JSON-parsed into a number.
    return sessionStorage.getItem('username');
  }

  setUserId(id: string): void {
    sessionStorage.setItem('userId', id);
  }

  getUserId(): string | null {
    return sessionStorage.getItem('userId');
  }

  // ✅ New: Permissions helpers
  setPermissions(permissions: string[]): void {
    this.setItem('permissions', permissions);
  }

  getPermissions(): string[] {
    return this.getItem<string[]>('permissions') || [];
  }

    // 🏢 CompanyId helpers
getUserCompanies(): any[] {
  return this.getItem<any[]>('userCompanies') ?? [];
}

getUserCompanyIds(): number[] {
  return this.getItem<number[]>('userCompanyIds') ?? [];
}

getCompanyId(): number {
  return this.getItem<number>('companyId') ?? 0;
}

getCompanyName(): string {
  return this.getItem<string>('companyName') ?? '';
}

// Set groupId dynamically
setGroupId(groupId: number): void {
  this.setItem('groupId', groupId);
}

// Get groupId safely
getGroupId(): number {
  return this.getItem<number>('groupId') ?? 0; // default 0 agar null
}
setCompanyLogo(logoPath: string): void {
  this.setItem('companyLogo', logoPath);
}

getCompanyLogo(): string {
  return this.getItem<string>('companyLogo') ?? '';
}

getCompanyAddress(): string {
  return this.getItem<string>('companyAddress') ?? '';
}

getCompanyContact(): string {
  return this.getItem<string>('companyContact') ?? '';
}

getCompanyEmail(): string {
  return this.getItem<string>('companyEmail') ?? '';
}

}
